import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate } from "../../../../utils/countdownTimerApi";
import '../../../../assets/css/app-countdown-timer-module.css';
import '../../../../assets/css/loader.css'; 

//Import Widgets
import DynamicTemplate from "../../../../components/Apps/CountdownTimer/Template/DynamicTemplate";

//Import Tabs
import TimerTab from "../../../../components/Apps/CountdownTimer/TimerTab";
import ButtonTab from "../../../../components/Apps/CountdownTimer/ButtonTab";
import AppearanceTab from "../../../../components/Apps/CountdownTimer/AppearanceTab";

export default function CreateCountdownTimer() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Timer");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Countdown_Timer_Temp");
    const [selectedLayout, setSelectedLayout] = useState("countdown_timer_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("countdown-timer.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Countdown Timer");
    const [newWidgetName, setNewWidgetName] = useState("");

    // Get today's date in "YYYY-MM-DD" format
    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];

    // Get end date (30 days from today) in "YYYY-MM-DD" format
    const endDate = new Date();
    endDate.setDate(today.getDate() + 30);
    const formattedEndDate = endDate.toISOString().split('T')[0];
    
    const [countdownTimerTabData, setCountdownTimerTabData] = useState({
        is_website_frontend: "", 
        timer_type: "",    
        timer_start_date: formattedToday,    
        timer_start_time: "12:00 AM",    
        timer_end_date: formattedEndDate, 
        timer_end_time: "12:00 AM",        
        timer_time_zone: "",    
        timer_position_type: "",    
        timer_message_before_timer: "⚡️ Limited-time offer! Sale ends in",    
        timer_counters_labels_displays_count: ["Days", "Hours", "Minutes", "Seconds"],    
        timer_days_label: "Days",    
        timer_hours_label: "Hours",    
        timer_minutes_label: "Minutes",    
        timer_seconds_label: "Seconds",    
        timer_action_after_timer_select_action: "",    
        timer_timer_align: "",    
        button_is_show_button: 1,    
        button_link: "https://dashboard.upgadeify.com",    
        button_text: "Shop Now",    
        button_is_open_link_in_new_tab: 1,    
        button_is_make_the_whole_timer_clickable: "",    
        appearance_style: "",    
        appearance_holiday_theme: "",    
        appearance_colors_timer_color: "",    
        appearance_colors_timer_text_color: "",    
        appearance_colors_labels_color: "",    
        appearance_colors_message_color: "",    
        appearance_colors_button_color: "",    
        appearance_colors_background_color: "",    
        appearance_message_font_size: "20",    
        appearance_timer_size: "20",    
        appearance_button_size: "20",    
        appearance_animation_type: "",    
        appearance_custom_css: "",    
        appearance_custom_js: "",    
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let timer_message_before_timer = "";
            let timer_position_type = "";
            let button_text = "";
            let appearance_colors_background_color = "";
            let appearance_colors_button_color = "";
            let appearance_colors_timer_color = "";
            let appearance_colors_timer_text_color = "";
            let appearance_colors_labels_color= "";
            let appearance_colors_message_color= "";
        
            switch (activeTemplateSection) {
                case "Countdown_Timer_Temp":
                    timer_position_type = "install_to_required_position";
                    timer_message_before_timer = "⚡️ Limited-time offer! Sale ends in";
                    button_text = "Shop Now";
                    appearance_colors_background_color = "#fff";
                    appearance_colors_button_color = "#f7e900";
                    appearance_colors_timer_color = "#1f50f6";
                    appearance_colors_timer_text_color = "#fff";
                    appearance_colors_labels_color = "#000";
                    appearance_colors_message_color = "#000";
                    break;
                case "Black_Friday_Sale_Banner_Temp":
                    timer_position_type = "floating_top_banner";
                    timer_message_before_timer = "Black Friday Sale up to 50% OFF";
                    button_text = "Shop Now";
                    appearance_colors_background_color = "";
                    appearance_colors_button_color = "rgb(249, 193, 0)";
                    appearance_colors_timer_color = "#f9c100";
                    appearance_colors_timer_text_color = "#000";
                    appearance_colors_labels_color = "#fff";
                    appearance_colors_message_color = "#FE8100";
                    break;
                case "Special_Offer_Banner_Temp":
                    timer_position_type = "floating_bottom_banner";
                    timer_message_before_timer = "Special Offer 30% OFF Your coupon";
                    button_text = "Shop Now";
                    appearance_colors_background_color = "#000";
                    appearance_colors_button_color = "rgb(249, 193, 0)";
                    appearance_colors_timer_color = "#f9c100";
                    appearance_colors_timer_text_color = "#000";
                    appearance_colors_labels_color = "#fff";
                    appearance_colors_message_color = "#fff";
                    break;
                case "Urgency_Countdown_Temp":
                    timer_position_type = "install_to_required_position";
                    timer_message_before_timer = "Get 50% off before it's too late ⏳";
                    button_text = "Purchase now";
                    appearance_colors_background_color = "#5626ba";
                    appearance_colors_button_color = "#4bd503";
                    appearance_colors_timer_color = "";
                    appearance_colors_timer_text_color = "#fff";
                    appearance_colors_labels_color = "#fff";
                    appearance_colors_message_color = "#fff";
                    break;
                case "Event_Start_Countdown_Temp":
                    timer_position_type = "install_to_required_position";
                    timer_message_before_timer = "OUR EVENT IS COMING UP IN:";
                    button_text = "Buy tickets";
                    appearance_colors_background_color = "";
                    appearance_colors_button_color = "#ff333c";
                    appearance_colors_timer_color = "";
                    appearance_colors_timer_text_color = "#1f50f6";
                    appearance_colors_labels_color = "#000";
                    appearance_colors_message_color = "#000";
                    break;
                case "Limited_Shipping_Banner_Temp":
                    timer_position_type = "static_top_banner";
                    timer_message_before_timer = "Make a purchase before the time is out and get free delivery 🚚";
                    button_text = "Shop Now";
                    appearance_colors_background_color = "";
                    appearance_colors_button_color = "";
                    appearance_colors_timer_color = "";
                    appearance_colors_timer_text_color = "#1f50f6";
                    appearance_colors_labels_color = "#000";
                    appearance_colors_message_color = "#000";
                    break;
                default:
                    timer_position_type = "";
                    timer_message_before_timer = "";
                    button_text = "Shop Now";
                    appearance_colors_background_color = "";
                    appearance_colors_button_color = "";
                    appearance_colors_timer_color = "";
                    appearance_colors_timer_text_color = "";
                    appearance_colors_labels_color = "";
                    appearance_colors_message_color = "";
            }
        
            // Update setCountdownTimerTabData state with the data
            setCountdownTimerTabData((prevData) => ({
                ...prevData,
                timer_position_type: timer_position_type,
                timer_message_before_timer: timer_message_before_timer,
                button_text: button_text,
                appearance_colors_background_color: appearance_colors_background_color,
                appearance_colors_button_color: appearance_colors_button_color,
                appearance_colors_timer_color: appearance_colors_timer_color,
                appearance_colors_timer_text_color: appearance_colors_timer_text_color,
                appearance_colors_labels_color: appearance_colors_labels_color,
                appearance_colors_message_color: appearance_colors_message_color,
                
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateCountdownTimerTabData = (key, value) => {
        setCountdownTimerTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

  const menuItems = [
      { key: "Timer", icon: "timer.png", label: "Timer" },
      { key: "Button", icon: "button.png", label: "Button" },
      { key: "Appearance", icon: "appearance.png", label: "Appearance" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

  //Submit Review data
  const submitForm = async (e) => {
      e.preventDefault();

      setIsSubmitting(true);
      try {
        // Collect data from refs
        const settingsArray = Object.entries(countdownTimerTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

          // Collect data from refs
          const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "Countdown_Timer",
                settings: settingsArray,
          };
          
          //Api Call
          let api_response = await submitTemplate(payload);

          //Check Responce
          if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/countdown-timer');
                }, 2000); 
          } else {
              toast.error(api_response.message);
          }
      } catch (error) {
          toast.error('Oops Something Wrong. Please Try Again!' + error.message);
      } finally {
          setIsSubmitting(false);
      }
  };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Countdown Timer" app_type="Countdown_Timer" app_slug="countdown-timer"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Countdown_Timer_Temp" data-layout_type="countdown_timer_layout" data-template_image="countdown-timer.png" checked={activeTemplateSection === "Countdown_Timer_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/countdown-timer/templates/countdown-timer.png`} alt="countdown-timer" />
                                    </div>
                                    <div className="content_sub">Countdown Timer</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Black_Friday_Sale_Banner_Temp" data-layout_type="black_friday_sale_banner_layout" data-template_image="black-friday.png" checked={activeTemplateSection === "Black_Friday_Sale_Banner_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/countdown-timer/templates/black-friday.png`} alt="black-friday" />
                                    </div>
                                    <div className="content_sub">Black Friday Sale Banner</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Special_Offer_Banner_Temp" data-layout_type="special_offer_banner_layout" data-template_image="special-offer-banner.png" checked={activeTemplateSection === "Special_Offer_Banner_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/countdown-timer/templates/special-offer-banner.png`} alt="special-offer-banner" />
                                    </div>
                                    <div className="content_sub">Special Offer Banner</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Urgency_Countdown_Temp" data-layout_type="urgency_countdown_layout" data-template_image="urgency-countdown.png" checked={activeTemplateSection === "Urgency_Countdown_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/countdown-timer/templates/urgency-countdown.png`} alt="urgency-countdown" />
                                    </div>
                                    <div className="content_sub">Urgency Countdown</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Event_Start_Countdown_Temp" data-layout_type="event_start_countdown_layout"  data-template_image="event-start-countdown.png" checked={activeTemplateSection === "Event_Start_Countdown_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/countdown-timer/templates/event-start-countdown.png`} alt="event-start-countdown" />
                                    </div>
                                    <div className="content_sub">Event Start Countdown</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Limited_Shipping_Banner_Temp" data-layout_type="limited_shipping_banner_layout" data-template_image="limited-shipping-banner.png" checked={activeTemplateSection === "Limited_Shipping_Banner_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/countdown-timer/templates/limited-shipping-banner.png`} alt="limited-shipping-banner" />
                                    </div>
                                    <div className="content_sub">Limited-Shipping Banner</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/countdown-timer/icons//${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Timer" && (
                              <TimerTab updateCountdownTimerTabData={updateCountdownTimerTabData} countdownTimerTabData={countdownTimerTabData} />
                            )}
                            {activeSection === "Button" && (
                              <ButtonTab updateCountdownTimerTabData={updateCountdownTimerTabData} countdownTimerTabData={countdownTimerTabData} />
                            )}
                            {activeSection === "Appearance" && (
                              <AppearanceTab updateCountdownTimerTabData={updateCountdownTimerTabData} countdownTimerTabData={countdownTimerTabData}/>
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/countdown-timer"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name countdown-timer-icon">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/images/app-icon/timer-color.svg`} alt="app-icon-2"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/countdown-timer/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/countdown-timer" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Countdown Timer <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Countdown_Timer_Temp" && (
                      <DynamicTemplate selectedTemplate="Countdown_Timer_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}

                    {activeTemplateSection === "Black_Friday_Sale_Banner_Temp" && (
                      <DynamicTemplate selectedTemplate="Black_Friday_Sale_Banner_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}

                    {activeTemplateSection === "Special_Offer_Banner_Temp" && (
                      <DynamicTemplate selectedTemplate="Special_Offer_Banner_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}

                    {activeTemplateSection === "Urgency_Countdown_Temp" && (
                      <DynamicTemplate selectedTemplate="Urgency_Countdown_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}

                    {activeTemplateSection === "Event_Start_Countdown_Temp" && (
                      <DynamicTemplate selectedTemplate="Event_Start_Countdown_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}

                    {activeTemplateSection === "Limited_Shipping_Banner_Temp" && (
                      <DynamicTemplate selectedTemplate="Limited_Shipping_Banner_Temp" countdownTimerTabData={countdownTimerTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 